// extracted by css-extract-rspack-plugin
export default {"images":"BeforeAfter-module__images--ymGlG"};